export default __webpack_public_path__ + "static/media/Vashian Tunic.7fa5d33a.jpg";